__turbopack_context__.v({
  "card": "_2_2qdG_card",
  "cardLabel": "_2_2qdG_cardLabel",
  "cardValue": "_2_2qdG_cardValue",
  "grid": "_2_2qdG_grid",
  "header": "_2_2qdG_header",
  "inlineCode": "_2_2qdG_inlineCode",
  "inlineLink": "_2_2qdG_inlineLink",
  "intro": "_2_2qdG_intro",
  "page": "_2_2qdG_page",
  "section": "_2_2qdG_section",
  "sectionTitle": "_2_2qdG_sectionTitle",
  "stat": "_2_2qdG_stat",
  "statGrid": "_2_2qdG_statGrid",
  "statLabel": "_2_2qdG_statLabel",
  "statNumber": "_2_2qdG_statNumber",
  "tokenDesc": "_2_2qdG_tokenDesc",
  "tokenItem": "_2_2qdG_tokenItem",
  "tokenList": "_2_2qdG_tokenList",
  "tokenName": "_2_2qdG_tokenName",
});
